import React, { createContext, useContext, useEffect, useState } from 'react'
import { getBrindesPorAcao } from '../api/brindes.servico'
import { getDescontoClubesAPI } from '../api/planos.servico'
import { func, node, number, oneOfType, string } from 'prop-types'
import { ETAPA_PLANO } from '../components/FluxosPagamento/constantsFluxosPagamento'
import { isEmptyObject, objetoTemPropriedade } from '../utils/helpers/helpers'
import { MODALIDADE_CURADORIA, MODALIDADE_INEDITOS, METODO_PAGAMENTO_PIX } from '../constants'
import { navigate } from '@reach/router'

const FluxosPagamentoContext = createContext()

function FluxosPagamentoProvider( { children, idAssinaturaAtual, fluxoPagamentoAtual, modalidadeParaBrinde, montarFluxoComBrindes, descontoCombo } ) {
  const [ brinde, setBrinde ] = useState()
  const [ dadosEtapas, setDadosEtapas ] = useState( {} )
  const [ errosDadosEtapas, setErrosDadosEtapas ] = useState( {} )
  const [ etapaAtiva, setEtapaAtiva ] = useState( 1 )
  const [ etapas, setEtapas ] = useState( {} )
  const [ idPlanoEscolhido, setIdPlanoEscolhido ] = useState()
  const [ planoInicial, setPlanoInicial ] = useState( {} )
  const [ temaFluxo, setTemaFluxo ] = useState( MODALIDADE_CURADORIA.cor )
  const [ modalidadeId, setModalidadeId ] = useState( MODALIDADE_CURADORIA.id )
  const fetchBrindes = () => montarFluxoComBrindes( [] )

  const getDadosDescontoCombo = async( { idAssinatura, idPlano } ) => {
    try {
      const resposta = await getDescontoClubesAPI( { idAssinatura, idPlano } )
      if ( !isEmptyObject( resposta.data ) ) {
        descontoCombo( resposta.data )
      }
    } catch ( erros ) {
      if ( erros && ( erros.request || erros.response ) ) {
        descontoCombo( {} )
      }
    }
  }

  const proximaEtapaAutocomplete = ( { etapaAtual } ) => {
    const proxima = etapas && Object.values( etapas ).find( etapa => etapa.codigo === etapaAtiva + 1 )
    if ( etapas[ etapaAtual.identificador ].autocompleted !== true && !window.location.href.includes( `#regularizar` ) ) {
      setEtapaAtiva( etapaAtiva + 1 )
      setEtapas( prevEtapas => ( {
        ...prevEtapas,
        [ etapaAtual.identificador ]: {
          ...prevEtapas[ etapaAtual.identificador ],
          'autocompleted': true,
          'completo': true,
        }
      } ) )
      navigate( proxima.url )
    }
  }

  useEffect( () => {
    if ( !isEmptyObject( dadosEtapas[ ETAPA_PLANO ] ) && idPlanoEscolhido !== dadosEtapas[ ETAPA_PLANO ].id && etapaAtiva === Object.values( etapas )[ 0 ].codigo ) {
      setIdPlanoEscolhido( dadosEtapas[ ETAPA_PLANO ].id )

      if ( descontoCombo ) {
        getDadosDescontoCombo( { 'idAssinatura': idAssinaturaAtual, 'idPlano': dadosEtapas[ ETAPA_PLANO ].id } )
      }

      setTemaFluxo( modalidadeParaBrinde === MODALIDADE_INEDITOS.id ? MODALIDADE_INEDITOS.cor : MODALIDADE_CURADORIA.cor )
      setModalidadeId( modalidadeParaBrinde )

      fetchBrindes()
    }
  }, [ dadosEtapas ] )

  const value = React.useMemo( () => {
    return {
      etapas,
      setEtapas
    }
  }, [ etapas ] )

  return (
    // eslint-disable-next-line react/jsx-no-constructed-context-values
    <FluxosPagamentoContext.Provider value={{
      ...value,
      brinde,
      dadosEtapas,
      errosDadosEtapas,
      etapaAtiva,
      fluxoPagamentoAtual,
      modalidadeId,
      modalidadeParaBrinde,
      montarFluxoComBrindes,
      planoInicial,
      proximaEtapaAutocomplete,
      setDadosEtapas,
      setErrosDadosEtapas,
      setEtapaAtiva,
      setPlanoInicial,
      temaFluxo }}
    >
      { children }
    </FluxosPagamentoContext.Provider>
  )
}

function useFluxosPagamento() {
  const context = useContext( FluxosPagamentoContext )

  if ( !context ) {
    throw new Error( 'FluxoPagamento compound component não deve ser usado fora do context de FluxoPagamento' )
  }

  const setarDadosEtapas = ( dadosEtapa, etapa ) => {
    context.setDadosEtapas( prevState => ( {
      ...prevState,
      [ etapa ]: dadosEtapa
    } ) )
  }

  const setarErrosDadosEtapas = ( erroEtapa, etapa ) => {
    context.setErrosDadosEtapas( prevState => ( {
      ...prevState,
      [ etapa ]: erroEtapa
    } ) )
  }

  const setarPlanoInicial = dadosPlano => {
    context.setPlanoInicial( dadosPlano )
  }

  function calculaDescontoPix( valor ) {
    const hasDescontoPix = METODO_PAGAMENTO_PIX.desconto !== 0
    if ( hasDescontoPix ) {
      const valorDescontoPix = METODO_PAGAMENTO_PIX.desconto / 100
      return valor - ( valor * valorDescontoPix )
    }
    return valor
  }

  return {
    ...context,
    calculaDescontoPix,
    setarDadosEtapas,
    setarErrosDadosEtapas,
    setarPlanoInicial,
  }
}

export { FluxosPagamentoProvider, useFluxosPagamento }

FluxosPagamentoProvider.defaultProps = {
  'descontoCombo': null,
  'fluxoPagamentoAtual': null,
  'idAssinaturaAtual': 0,
  'modalidadeParaBrinde': 1,
  'montarFluxoComBrindes': null
}

FluxosPagamentoProvider.propTypes = {
  'children': node.isRequired,
  'descontoCombo': func,
  'fluxoPagamentoAtual': string,
  'idAssinaturaAtual': number,
  'modalidadeParaBrinde': oneOfType( [ number, string ] ),
  'montarFluxoComBrindes': func
}
